export default __webpack_public_path__ + "static/media/Carucci.00ac62be.png";